import React from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

// Style
import "../../../style/home/Header.scss";

// Images
import logo from "../../../images/ic_logo_home.svg";

export const breakpoints = {
  mobile: `max-width: 1200px`,
  desktop: `min-width: 1200px`,
};

const Header = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: `(${breakpoints.mobile})` });

  const handleLoginRoute = () => {
    navigate("/login");
  };

  return (
    <div className="headerWrapper">
      <div className="headerContent">
        <img src={logo} alt={logo} />

        {!isMobile && (
          <div className="loginHeaderButton">
            <a
              href="https://calendly.com/luca-arena/30min"
              target="_blank"
              className="button"
            >
              Book a demo
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
